import { render, staticRenderFns } from "./SmsRatesInfo.vue?vue&type=template&id=ed913de4&scoped=true&lang=pug"
import script from "./SmsRatesInfo.vue?vue&type=script&lang=js"
export * from "./SmsRatesInfo.vue?vue&type=script&lang=js"
import style0 from "./SmsRatesInfo.vue?vue&type=style&index=0&id=ed913de4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed913de4",
  null
  
)

export default component.exports